import React, { useEffect } from "react";

import { Grid, makeStyles, Typography } from "@material-ui/core/";
import { useSelector } from "react-redux";
import Aux from "../../../hoc/Auxilliary";
import mainLogo from "../../../assests/about.png";
import localizedStrings from "../../../utils/localize";

const useStyle = makeStyles((theme) => ({
  rootContainer: {
    display: "flex",
    flexDirection: "column",
    // alignItems: "center",
    width: "100%",
    padding: "2rem 0",
  },
  heading: {
    color: "#005598",
    fontSize: "1.5rem",
    fontWeight: 400,
  },
  bodyMainContent: {
    display: "flex",
    justifyContent: "space-around",
  },
  bodyText: {
    fontSize: "1rem",
    color: "#000",
    marginTop: "1rem",
    paddingRight: "1rem",
    textTransform: "capitalize",
  },
  logoResponsive: {
    display: "flex",
    alignItems: "center",
    height: "100%",
    width: "90%",
    opacity: "0.8",
    [theme.breakpoints.down("xs")]: {
      width: "50%",
      marginLeft: "0",
      display: "none",
    },
  },
}));

function About(props) {
  const classes = useStyle(props);

  //current lagnguage
  const language = useSelector((state) => state.language.language);
  //set the current language to localize string
  localizedStrings.setLanguage(language);
  useEffect(() => {
    localizedStrings.setLanguage(language);
  }, [language]);
  return (
    <Aux>
      <div className={classes.rootContainer}>
        <Typography component="h1" className={classes.heading}>
          {localizedStrings.homePage.about.about}
        </Typography>
        <Grid container item className={classes.bodyMainContent}>
          <Grid item xs={11} sm={9}>
            <Typography className={classes.bodyText}>
              {localizedStrings.homePage.about.desciption}
            </Typography>
          </Grid>
          <Grid item xs={11} sm={3}>
            <div className={classes.logoResponsive}>
              {/* <img src={mainLogo} width="50%" alt="oneWorld logo" /> */}
            </div>
          </Grid>
        </Grid>
      </div>
    </Aux>
  );
}

export default About;
